import React, { useState, useEffect } from 'react';
import {
    Dialog,
    DialogContent,
    IconButton,
} from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import FullscreenIcon from '@mui/icons-material/Fullscreen';
import FullscreenExitIcon from '@mui/icons-material/FullscreenExit';
import { ColorRing } from 'react-loader-spinner';
import {
    proposalBasicInfo,
    proposalStatusInfo,
    proposalDetailsInfo,

} from "./config";
import NavigateBeforeIcon from '@mui/icons-material/NavigateBefore';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import { RenderFields } from '../../../maintenance/components/Maintenance Contract Entry/RenderFields';
import VirtualizedAutocomplete from '../../../../components/Dropdown/VirtualizedAutocomplete';
import CustomerAccordion from '../../../setup/components/Customer/accordion/CustomerAccordion';
import API_BASE_URL from '../../../../Constants';
import WorkPhaseModal from '../WorkPhase/WorkPhaseModal';

import { downloadProposalPdf } from './useProposalsFormLogic';

import NavHeightAdjust from '../../../../components/navbar/NavHeightAdjust';



const ViewEditProposalsModal = ({ open, handleClose, proposal, setProposal, setNext, setPrev, allProposals, updateAll, allOptions }) => {
    const [isEditMode, setIsEditMode] = useState(false);
    const [isFullView, setIsFullView] = useState(false);
    const [proposalData, setProposalData] = useState(proposal || {});
    const [options, setOptions] = useState(allOptions || {});
    const [isLoading, setIsLoading] = useState(false);
    const [isPhaseModalOpen, setIsPhaseModalOpen] = useState(false);

    useEffect(() => {
        setOptions(allOptions || {});
    }, [allOptions])

    useEffect(() => {
        if (proposal) {
            setProposalData(proposal);
        }
    }, [proposal])

    useEffect(() => {
        setIsEditMode(false);
    }, [open])

    const toggleEditMode = () => {
        setIsEditMode(!isEditMode);
    };


    const handleSaveChanges = async () => {

        console.log("Saving changes to proposal data:", proposalData);



        try {
            setIsLoading(true);
            const response = await fetch(`${API_BASE_URL}/api/proposals-and-jobs/proposals/${proposalData.proposalNumber}`, {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json',
                },
                credentials: 'include',
                body: JSON.stringify(proposalData),
            });
            if (!response.ok) {
                throw new Error('Network response was not ok');
            }
            const data = await response.json();
            updateProposals(data);
        } catch (error) {
            console.error('Fetch error: ', error);
        }
        finally {
            setIsLoading(false);
            setIsEditMode(false);
        }
    };


    const updateProposals = (proposal, isDelete = false) => {
        let all = [...allProposals]
        let index = all.findIndex((c) => String(c.proposalNumber) === String(proposal.proposalNumber));
        if (isDelete) {
            all.splice(index, 1);
        } else {
            all[index] = proposal;
        }
        updateAll(all);
    }

    const handleFieldChange = (e) => {
        const { name, value } = e.target;
        setProposalData((prevData) => ({ ...prevData, [name]: value }));
    };




    const splitFields = (fieldsArray) => {
        const midIndex = Math.ceil(fieldsArray.length / 2);
        return [fieldsArray.slice(0, midIndex), fieldsArray.slice(midIndex)];
    };

    if (!proposal) return null

    return (

        <>
            {/* Previous and Next Buttons placed outside the modal */}
            {open && !isEditMode && (
                <IconButton
                    onClick={setPrev}
                    sx={{
                        position: 'fixed',
                        left: 8,
                        top: '50%',
                        transform: 'translateY(-50%)',
                        backgroundColor: '#ffffff',
                        border: '1px solid #ccc',
                        zIndex: 1301, // Higher than the modal's z-index
                        '&:hover': {
                            backgroundColor: '#f0f0f0',
                        },
                    }}
                    aria-label="Previous Customer"
                >
                    <NavigateBeforeIcon />
                </IconButton>
            )}

            {open && !isEditMode && (
                <IconButton
                    onClick={setNext}
                    sx={{
                        position: 'fixed',
                        right: 8,
                        top: '50%',
                        transform: 'translateY(-50%)',
                        backgroundColor: '#ffffff',
                        border: '1px solid #ccc',
                        zIndex: 1301,
                        '&:hover': {
                            backgroundColor: '#f0f0f0',
                        },
                    }}
                    aria-label="Next Customer"
                >
                    <NavigateNextIcon />
                </IconButton>
            )}



            <Dialog
                open={open}
                onClose={handleClose}
                maxWidth="xl"
                fullWidth={true}
                fullScreen={isFullView}
                PaperProps={{
                    sx: {
                        backgroundColor: 'white',
                        boxShadow: 'none',
                        margin: isFullView ? 2 : 'auto',
                        width: isFullView ? 'calc(100% - 32px)' : '80%',
                        height: isFullView ? 'calc(100% - 62px)' : '80%',
                        marginTop: isFullView ? '12%' : '8%'
                    },
                }}
            >

                {/* Header */}
                <div className="sticky top-0 bg-white z-10">
                    <div className="flex justify-between items-center p-4">
                        {/* Left section: Back button and title */}
                        <div className="flex items-center space-x-4 flex-grow">
                            <button
                                onClick={handleClose}
                                className="p-2 rounded-full hover:bg-gray-200 transition"
                                aria-label="Back"
                            >
                                <ArrowBackIcon />
                            </button>
                            <h2 className="text-2xl font-bold text-left">
                                {isEditMode
                                    ? `Edit Proposal`
                                    : `View Proposal`} - {proposalData.proposalNumber}
                            </h2>
                        </div>
                        {/* Right section: Expand/Shrink Button */}
                        <button
                            onClick={() => setIsFullView(!isFullView)}
                            className="p-2 rounded-full hover:bg-gray-200 transition"
                            aria-label={isFullView ? 'Shrink Modal' : 'Expand Modal'}
                        >
                            {isFullView ? <FullscreenExitIcon /> : <FullscreenIcon />}
                        </button>
                    </div>
                    <div className="flex space-x-4 p-4">

                        <button
                            className="px-6 py-2 bg-blue-600 text-white font-bold rounded-md hover:bg-blue-700 transition"
                            onClick={() => setIsPhaseModalOpen(true)}
                        >
                            Manage Work Phases
                        </button>

                        <button
                            onClick={() => downloadProposalPdf(proposalData.proposalNumber, setIsLoading)}
                            className="px-6 py-2 bg-blue-600 text-white font-bold rounded-md hover:bg-blue-700 transition"
                        >
                            Export PDF
                        </button>

                        {isEditMode ? (
                            <>
                                <button
                                    onClick={toggleEditMode}
                                    className="px-4 py-2 bg-sss-light-gray text-sss-blue-sel font-bold rounded-md hover:bg-gray-400 transition"
                                >
                                    Cancel
                                </button>
                                <button
                                    onClick={handleSaveChanges}
                                    className="px-6 py-2 bg-sss-accent-yel text-sss-blue-sel font-bold rounded-md hover:bg-yellow-600 transition"
                                >
                                    Save
                                </button>
                            </>
                        ) : (
                            <button
                                onClick={toggleEditMode}
                                className="px-6 py-2 bg-sss-accent-yel text-sss-blue-sel font-bold rounded-md hover:bg-yellow-600 transition"
                            >
                                Edit
                            </button>
                        )}
                    </div>
                </div>

                {
                    isLoading ? (
                        <div className="flex justify-center items-center h-full">
                            <ColorRing color="#247399" />
                        </div>
                    ) :
                        (

                            <DialogContent


                                dividers
                                sx={{
                                    padding: 0,
                                    maxHeight: '90vh',
                                    overflowY: 'auto',
                                    display: 'flex',
                                    flexDirection: 'column',
                                }}
                            >

                                {/* Basic Info Accordion */}
                                {(() => {
                                    const [generalInfoLeft, generalInfoRight] = splitFields(
                                        proposalBasicInfo
                                    );
                                    return (
                                        <CustomerAccordion label="General Info">
                                            <div
                                                className={`flex ${isFullView ? 'flex-row' : 'flex-col md:flex-row'
                                                    } gap-4`}
                                            >
                                                <div className="w-full">
                                                    <RenderFields
                                                        fields={generalInfoLeft}
                                                        formData={proposalData}
                                                        handleChange={handleFieldChange}
                                                        readOnly={!isEditMode}
                                                        allOptions={options}
                                                    />
                                                </div>
                                                <div className="w-full">
                                                    <RenderFields
                                                        fields={generalInfoRight}
                                                        formData={proposalData}
                                                        handleChange={handleFieldChange}
                                                        readOnly={!isEditMode}
                                                        allOptions={options}

                                                    />
                                                </div>
                                            </div>

                                            <div
                                                className={`flex ${isFullView ? 'flex-row' : 'flex-col md:flex-row'
                                                    } gap-4`}>

                                                <div className='flex flex-row w-2/3'>


                                                    {isEditMode ? (
                                                        <>
                                                            <label className="w-1/3 h-10 flex items-center bg-gray-200 px-4 py-2 text-left font-bold text-sss-blue-sel border border-gray-300">
                                                                Sales Rep
                                                            </label>


                                                            <VirtualizedAutocomplete
                                                                options={options.salesPerson || []}
                                                                value={proposalData.salesPerson}
                                                                disabled={!isEditMode}
                                                                name="salesPerson"
                                                                onChange={(e, newValue) => {

                                                                    setProposalData((prev) => ({ ...prev, salesPerson: newValue }));

                                                                }}

                                                                optionKey="salesPerson"
                                                                optionLabel="firstName"


                                                                renderOption={(props, option, state) => (
                                                                    <li {...props} key={option.id} value={option} >
                                                                        {option.id} - {option.firstName} {option.lastName}
                                                                    </li>
                                                                )}


                                                                filterOptions={(options, state) => {
                                                                    const inputValue = state.inputValue.toLowerCase();
                                                                    if (inputValue.trim() === '' || inputValue === null) { return options }
                                                                    return options.filter((option) =>
                                                                        (option.firstName || '').toLowerCase().includes(inputValue) ||
                                                                        (option.lastName || '').toLowerCase().includes(inputValue) ||
                                                                        (option.id || '').toString().toLowerCase().includes(inputValue)
                                                                    );
                                                                }}

                                                            />
                                                        </>) : (
                                                        <>

                                                            <label className="w-1/3 h-10 flex items-center bg-gray-200 px-4 py-2 text-left font-bold text-sss-blue-sel border border-gray-300">
                                                                Sales Rep
                                                            </label>
                                                            <span
                                                                className={`h-10 border  border-gray-300 flex-grow px-4 bg-gray-100 flex items-center`}
                                                                style={{ minWidth: '200px' }}
                                                            >
                                                                {proposalData?.salesPerson?.firstName} {proposalData?.salesPerson?.lastName}
                                                            </span>

                                                        </>
                                                    )}
                                                </div>

                                                <div className='flex flex-row w-2/3'>


                                                    {isEditMode ? (
                                                        <>
                                                            <label className="w-1/3 h-10 flex items-center bg-gray-200 px-4 py-2 text-left font-bold text-sss-blue-sel border border-gray-300">
                                                                Contact
                                                            </label>


                                                            <VirtualizedAutocomplete
                                                                options={options.contact || []}
                                                                value={proposalData.contact}
                                                                disabled={!isEditMode}
                                                                name="contact"
                                                                onChange={(e, newValue) => {

                                                                    setProposalData((prev) => ({ ...prev, contact: newValue }));

                                                                }}

                                                                optionKey="contact"
                                                                optionLabel="contactName"


                                                                renderOption={(props, option, state) => (
                                                                    <li {...props} key={option.contactID} value={option} >
                                                                        {option.contactID} - {option.contactName} - {option.cellPhone}
                                                                    </li>
                                                                )}


                                                                filterOptions={(options, state) => {
                                                                    const inputValue = state.inputValue.toLowerCase();
                                                                    if (inputValue.trim() === '' || inputValue === null) { return options }
                                                                    return options.filter((option) =>

                                                                        (option.contactName || '').toLowerCase().includes(inputValue) ||
                                                                        (option.contactID || '').toString().toLowerCase().includes(inputValue) ||
                                                                        (option.contactPhone || '').toString().toLowerCase().includes(inputValue)
                                                                    );
                                                                }}

                                                            />
                                                        </>) : (
                                                        <>

                                                            <label className="w-1/3 h-10 flex items-center bg-gray-200 px-4 py-2 text-left font-bold text-sss-blue-sel border border-gray-300">
                                                                Contact
                                                            </label>
                                                            <span
                                                                className={`h-10 border  border-gray-300 flex-grow px-4 bg-gray-100 flex items-center`}
                                                                style={{ minWidth: '200px' }}
                                                            >
                                                                {proposalData?.contact?.contactName} - {proposalData?.contact?.cellPhone}
                                                            </span>

                                                        </>
                                                    )}



                                                </div>
                                            </div>
                                        </CustomerAccordion>
                                    );
                                })()}


                                {/* Status Info Accordion */}
                                {(() => {
                                    const [generalInfoLeft, generalInfoRight] = splitFields(
                                        proposalStatusInfo
                                    );
                                    return (
                                        <CustomerAccordion label="Status Info">

                                            <div
                                                className={`flex ${isFullView ? 'flex-row' : 'flex-col md:flex-row'
                                                    } gap-4`}
                                            >
                                                <div key={"Proposal Class"} className="flex flex-col w-full">
                                                    <div className="flex justify-between items-center w-full pb-2">
                                                        <>

                                                            <label className="w-1/3 h-10 flex items-center bg-gray-200 px-4 py-2 text-left font-bold text-sss-blue-sel border border-gray-300">
                                                                Proposal Class
                                                            </label>
                                                            <span
                                                                className={`h-10 border border-gray-300 flex-grow px-4 bg-gray-100 flex items-center`}
                                                                style={{ minWidth: '200px' }}
                                                            >
                                                                {proposalData?.proposalSubClass?.proposalClass?.className || 'N/A'}
                                                            </span>

                                                        </>

                                                    </div>

                                                </div>

                                                <div key={"proposalSubClass"} className="flex flex-col w-full">
                                                    <div className="flex justify-between items-center w-full pb-2">

                                                        {isEditMode ? (
                                                            <>
                                                                <label className="w-1/3 h-10 flex items-center bg-gray-200 px-4 py-2 text-left font-bold text-sss-blue-sel border border-gray-300">
                                                                    Proposal SubClass
                                                                </label>

                                                                <VirtualizedAutocomplete
                                                                    options={options.proposalSubClass || []}
                                                                    value={proposalData.proposalSubClass}
                                                                    disabled={!isEditMode}
                                                                    name="proposalSubClass"
                                                                    onChange={(e, newValue) => {

                                                                        setProposalData((prev) => ({ ...prev, proposalSubClass: newValue }));

                                                                    }}

                                                                    optionKey="subClassId"
                                                                    optionLabel="subClassName"


                                                                    renderOption={(props, option, state) => (
                                                                        <li {...props} key={option.subClassId} value={option} >
                                                                            {option.proposalClass.className} - {option.subClassName}
                                                                        </li>
                                                                    )}


                                                                    filterOptions={(options, state) => {
                                                                        const inputValue = state.inputValue.toLowerCase();
                                                                        if (inputValue.trim() === '' || inputValue === null) { return options }
                                                                        return options.filter((option) =>

                                                                            (option.subClassName || '').toLowerCase().includes(inputValue) ||
                                                                            (option.proposalClass.className || '').toString().toLowerCase().includes(inputValue)
                                                                        );
                                                                    }}

                                                                />
                                                            </>) : (
                                                            <>

                                                                <label className="w-1/3 h-10 flex items-center bg-gray-200 px-4 py-2 text-left font-bold text-sss-blue-sel border border-gray-300">
                                                                    Proposal SubClass
                                                                </label>
                                                                <span
                                                                    className={`h-10 border border-gray-300 flex-grow px-4 bg-gray-100 flex items-center`}
                                                                    style={{ minWidth: '200px' }}
                                                                >
                                                                    {proposalData?.proposalSubClass?.subClassName || 'N/A'}
                                                                </span>

                                                            </>
                                                        )}


                                                    </div>




                                                </div>

                                            </div>


                                            <div
                                                className={`flex ${isFullView ? 'flex-row' : 'flex-col md:flex-row'
                                                    } gap-4`}
                                            >
                                                <div className="w-full">
                                                    <RenderFields
                                                        fields={generalInfoLeft}
                                                        formData={proposalData}
                                                        handleChange={handleFieldChange}
                                                        readOnly={!isEditMode}
                                                        allOptions={options}
                                                    />
                                                </div>
                                                <div className="w-full">
                                                    <RenderFields
                                                        fields={generalInfoRight}
                                                        formData={proposalData}
                                                        handleChange={handleFieldChange}
                                                        readOnly={!isEditMode}
                                                        allOptions={options}

                                                    />
                                                </div>
                                            </div>
                                        </CustomerAccordion>
                                    );
                                })()}

                                {/* Details Accordion */}
                                {(() => {
                                    const [generalInfoLeft, generalInfoRight] = splitFields(
                                        proposalDetailsInfo
                                    );
                                    return (
                                        <CustomerAccordion label="Proposals Details Info">
                                            <div
                                                className={`flex ${isFullView ? 'flex-row' : 'flex-col md:flex-row'
                                                    } gap-4`}
                                            >
                                                <div className="w-full">
                                                    <RenderFields
                                                        fields={generalInfoLeft}
                                                        formData={proposalData}
                                                        handleChange={handleFieldChange}
                                                        readOnly={!isEditMode}
                                                        allOptions={options}
                                                    />
                                                </div>
                                                <div className="w-full">
                                                    <RenderFields
                                                        fields={generalInfoRight}
                                                        formData={proposalData}
                                                        handleChange={handleFieldChange}
                                                        readOnly={!isEditMode}
                                                        allOptions={options}

                                                    />
                                                </div>
                                            </div>
                                        </CustomerAccordion>
                                    );
                                })()}

                            </DialogContent>)}
            </Dialog>

            <WorkPhaseModal
                open={isPhaseModalOpen}
                handleClose={() => setIsPhaseModalOpen(false)}
                proposalNumber={proposal?.proposalNumber}
                buildingId={proposal?.building?.buildingId || proposal?.building?.buildingID}
            />

        </>

    );
};

export default ViewEditProposalsModal;
